import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { fg, withoutFeatureExistenceCheck } from '@atlassian/jira-feature-gating';
import type { ResolverOverride } from '../../common/types.tsx';
import { ff } from '../get-feature-flag-value/index.tsx';

/**
 * For the visual refresh, all usages of initPlatformFeatureFlags require this override. `visualRefreshResolverOverride`.
 * Will be cleaned up with visual-refresh.
 */
export const initPlatformFeatureFlags = ([isOverride, resolver]: ResolverOverride) => {
	setBooleanFeatureFlagResolver((flagKey) =>
		// disable existence check as platform feature >flags< might not be gates
		withoutFeatureExistenceCheck(() =>
			isOverride(flagKey) ? resolver(flagKey) : fg(flagKey) || ff(flagKey),
		),
	);
};
